import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateConfig } from './config'

import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool
let { Session } = utils_tool
class ThirdCorpUser extends WizContainer {

  componentName = 'thirdCorpUser';

  constructor(props) {
    super(props);
    this.state = {}

    const { history } = this.props;
    let record = {};
    if (history.location && history.location.pathname === '/auth/corpManager/userManager') {
      if(history.location && history.location.record){
        record = history.location.record;
        Session.set('thirdUserInfo', record)
      }else{
        record = Session.get('thirdUserInfo') || {};
      }
    }

    this.record = record;
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile = (nextProps, nextState, key) => {
    let o = nextProps[key]

    if (o.success) {
      let columns = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
          },
        },
        this.getFileRow('账号', 'userName', 20),
        this.getFileRow('姓名', 'fullName', 20),
        this.getFileRow('证件号码', 'idCard', 20),
        this.getFileRow('状态', 'state', 10),
        this.getFileRow('手机号', 'mobile', 20),
        this.getFileRow('任职信息', 'identityStr', 30),
        this.getFileRow('企业账号状态', 'corpUserState', 20),
        this.getFileRow('企业内账号', 'userId', 20),
        this.getFileRow('openId', 'openId', 25),
      ];
      let stateEnum = {0: '禁用', 1: '激活'}
      let corpUserStateEnum = {0: '否', 1: '是'}
      let rows = o.data && o.data.map(item => {
        item['state'] = stateEnum[item['state']]
        item['corpUserState'] = corpUserStateEnum[item['corpUserState']]
        item['identityStr'] = item['identityInfos'] && item['identityInfos'].map(tmp => tmp['orgName'] +'-'+ tmp['positionName']).join(',') || ''
        return item;
      }) || []

      WizBrowserExport({
        title: '人员列表',
        sheetName: '人员列表',
        columns: columns.filter((_, index) => index),
        rows,
        filename: '人员列表.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o.msg)
      return false
    }
  }

  getFileRow(headerName, field, width) {
    return {
      headerName: headerName,
      field: field,
      width: width,
      cellStyle: {textAlign: 'center'},
      style: {alignment: { vertical: 'bottom', horizontal: 'left' }}
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig(this,{
      templateConfig: templateConfig(this),
      apiDataFormat: {
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ThirdCorpUser);
